import React from "react";
import {
  ApplicationChapterId,
  ApplicationFlows,
  ApplicationFlowSteps,
} from "../types";
import NoApplicationsCurrentStep from "./noApplicationsCurrentStep";
import ApplicationFlowProvider from "../applicationFlowContext";

interface PropTypes {
  activeChapter: ApplicationChapterId;
  step: ApplicationFlowSteps;
  setStep: (step: ApplicationFlowSteps) => void;
  triggerReload: () => void;
}

const NoApplicationsPresentFlow = ({
  activeChapter,
  step,
  setStep,
  triggerReload,
}: PropTypes): React.JSX.Element => {
  return (
    <ApplicationFlowProvider
      flow={ApplicationFlows.NO_APPLICATIONS_FLOW}
      activeChapter={activeChapter}
      setStep={setStep}
    >
      <NoApplicationsCurrentStep
        step={step}
        setStep={setStep}
        triggerReload={triggerReload}
      />
    </ApplicationFlowProvider>
  );
};

export default NoApplicationsPresentFlow;
